import { Piece, PieceAction, User, UserMin } from '@apiContract';

import { AddEvent } from './useUpdateQueue';
import { useMe } from '@hooks/useMe';

export const useAssignmentRecipient = (addEvent: (param: AddEvent) => void) => {
  const { currentUser } = useMe();

  const assignRecipientToPiece = (recipient: User | UserMin, piece: Piece) => {
    if (currentUser && piece) {
      addEvent({
        event: { id: piece.id, recipientId: recipient.id },
        action: PieceAction.Assign,
        source: 'user',
      });
    }
  };
  return { assignRecipientToPiece };
};
